<template>
  <ArtboardFrame>
    <h1 class="heading">{{ t.thankYouHeading }}</h1>

    <p class="body">
      <span v-for="line in t.thankYouBody" :key="line" class="body__line">{{ line }}</span>
    </p>

    <dl class="summary">
      <template v-for="row in t.thankYouSummary" :key="row.label">
        <dt class="summary__label">{{ row.label }}</dt>
        <dd class="summary__value">{{ row.value }}</dd>
      </template>
    </dl>

    <CtaButton v-if="portalHref" :label="t.thankYouCta" @click="onContinueClicked"/>

    <PageFooter/>
  </ArtboardFrame>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import ArtboardFrame from "@/components/ArtboardFrame.vue";
import CtaButton from "@/components/CtaButton.vue";
import PageFooter from "@/components/PageFooter.vue";
import {triggerGTMEvent} from "@/functions/addGTM";

export default {
  name: 'ThankYouPage',
  components: {ArtboardFrame, CtaButton, PageFooter},
  computed: {
    ...mapState(['brandConfig', 'msisdn']),
    ...mapGetters(['t']),
    /* The msisdn AIS hand back is what One81 turn into an auto login, so it rides along
       whenever we have it. */
    portalHref() {
      if (!this.brandConfig.portalUrl) return undefined;

      const portalUrl = new URL(this.brandConfig.portalUrl);
      if (this.msisdn) portalUrl.searchParams.set('msisdn', this.msisdn);
      return portalUrl.toString();
    }
  },
  methods: {
    onContinueClicked() {
      triggerGTMEvent('continue_to_portal_clicked');
      window.location.href = this.portalHref;
    }
  },
  mounted() {
    triggerGTMEvent('thank_you_page_view');
  }
}
</script>

<style scoped>
.heading {
  position: absolute;
  top: calc(330.1 * var(--u));
  left: 0;
  right: 0;
  margin: 0;
  font-size: calc(20 * var(--u));
  line-height: 1;
  font-weight: 700;
  text-align: center;
  color: var(--slate);
}

.body {
  position: absolute;
  top: calc(368.6 * var(--u));
  left: 0;
  right: 0;
  margin: 0;
  font-size: calc(11.9 * var(--u));
  line-height: calc(18 * var(--u));
  font-weight: 600;
  text-align: center;
  color: var(--body-grey);
}

.body__line {
  display: block;
}

.summary {
  position: absolute;
  top: calc(470 * var(--u));
  left: calc(52 * var(--u));
  right: calc(52 * var(--u));
  display: grid;
  grid-template-columns: auto auto;
  align-items: baseline;
  row-gap: calc(14 * var(--u));
  margin: 0;
  font-size: calc(11.5 * var(--u));
  line-height: 1.3;
}

.summary__label {
  font-weight: 700;
  text-align: left;
  color: var(--slate);
}

.summary__value {
  margin: 0;
  font-weight: 500;
  text-align: right;
  color: var(--body-grey);
}
</style>
